import type { Maybe } from '../../../types'

export const getCohortKey = (cohort: {
  key: Maybe<string>
  field: Maybe<string>
  level: number
}): string => `${cohort.field}__${cohort.key}__${cohort.level}`
